import {
    Box,
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TableCell
} from '@mui/material';
import { useAppSelector } from '../../hooks/reduxHooks';
import DataTableRow from './DataTableRow';
import Loading from '../Loading';
import NoInfo from '../NoInfo';
import styles from './styles.module.css';
import { useIsMobile } from '../../hooks/useIsMobile';

const MainTable = (props: any) => {
    const {
        items,
        children,
        isFetching,
        style,
        headers,
        columnTitles,
        columnWidths,
        noInfoTitle,
        noInfoSubtitle,
        testID,
        noInfoText = 'noItems',
        hideNoDataMessage = false,
        getRowDisabled,
        noInfoImage
    } = props;
    const { isMobile } = useIsMobile();
    const { loading } = useAppSelector((state) => state.application);

    return (
        <Box sx={style || null}>
            <Paper>
                <TableContainer
                    sx={{
                        maxHeight: '746px',
                        width: '100%',
                        overflowY: 'auto',
                        overflowX: 'auto'
                    }}
                >
                    <Table
                        data-testid={testID || 'table'}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                        className={styles['datatable']}
                        stickyHeader
                        sx={{
                            width: '100%'
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                {columnTitles.map((title: string, index: number) => {
                                    const isLastColumn = index === columnTitles.length - 1;
                                    return (
                                        <TableCell
                                            key={index}
                                            style={{
                                                //backgroundColor: '#384A52',
                                                // color: 'white',
                                                width: columnWidths[index],
                                                paddingTop: '1rem',
                                                paddingBottom: '1rem',
                                                fontSize: '1rem',
                                                paddingLeft: '.7rem',
                                                position:
                                                    isMobile && isLastColumn ? 'sticky' : 'static',
                                                right: isMobile && isLastColumn ? 0 : undefined,
                                                zIndex: isMobile && isLastColumn ? 2 : undefined
                                            }}
                                        >
                                            {title}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody className={styles['datatable-tbody']}>
                            {isFetching || loading ? (
                                <TableRow>
                                    <TableCell colSpan={headers?.length}>
                                        <Loading size="small" />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                items?.map((item: any, index: number) => (
                                    <DataTableRow
                                        key={item?.id || index}
                                        columnWidths={columnWidths}
                                        item={item}
                                        headers={headers}
                                        isMobile={isMobile}
                                        getRowDisabled={getRowDisabled}
                                        {...props}
                                    />
                                ))
                            )}
                        </TableBody>
                    </Table>
                    {items === undefined && !loading && !isFetching && !hideNoDataMessage && (
                        <NoInfo title={noInfoTitle} subtitle={noInfoSubtitle} image={noInfoImage} />
                    )}
                    {items?.length < 1 && !loading && !isFetching && !hideNoDataMessage && (
                        <NoInfo
                            text={noInfoText}
                            title={noInfoTitle}
                            subtitle={noInfoSubtitle}
                            image={noInfoImage}
                        />
                    )}
                </TableContainer>
            </Paper>
            <div>
                <span>{children}</span>
            </div>
        </Box>
    );
};

export default MainTable;
